import { createAsyncThunk } from '@reduxjs/toolkit'

import { callErrorMsg } from 'helpers/errorMsg'
import { vendor } from 'config/routes'

import { postReview } from 'features/Enterprise/Vendor/services/addEditVendor'
import { getVendorDetailRequest } from 'features/Enterprise/Vendor/services/vendorReview'

import { push } from 'utils/helpers/router'

import { toastSuccess } from 'utils/toast'

import { SLICE_NAME, setLoading, setPrincipalDetails } from './principalReviewSlice'

export const fetchPrincipalReview = createAsyncThunk(
  `${SLICE_NAME}/fetchPrincipalReview`,
  async ({ principal_id }: { principal_id: string }, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      const { data } = await getVendorDetailRequest(principal_id)

      if (!data.error.status) {
        const requestData = data.data.request_data || {}
        const newReqData = {
          ...requestData,
          status: data.data.status,
          reason: data.data.reason,
        }
        dispatch(setPrincipalDetails(newReqData))
      }
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const submitReviewPrincipal = createAsyncThunk(
  `${SLICE_NAME}/submitReviewPrincipal`,
  async (
    {
      data,
      id,
      vendorName,
    }: {
      data: { id: number; action: string; reason: string }
      id: number | string
      vendorName?: string
    },
    { dispatch },
  ) => {
    try {
      dispatch(setLoading(true))
      await postReview(id, data)

      if (data.action !== 'REVIEWED') {
        dispatch(
          push({
            url: vendor,
            paramsUrl: { id },
            queryObject: { section: 'approvals' },
          }),
        )
      } else {
        const { data: refreshedData } = await getVendorDetailRequest(id.toString())

        if (!refreshedData.error.status) {
          const requestData = refreshedData.data.request_data || {}
          const newReqData = {
            ...requestData,
            status: refreshedData.data.status,
            reason: refreshedData.data.reason,
          }
          dispatch(setPrincipalDetails(newReqData))
        }
      }

      let message = `Dokumen ${vendorName} berhasil disetujui`
      if (data.action === 'REJECTED') message = `Dokumen ${vendorName} Ditolak-Menunggu Revisi`
      else if (data.action === 'CANCELLED') message = `Dokumen ${vendorName} dibatalkan`

      if (data.action !== 'REVIEWED') toastSuccess(message)
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)
